import { render } from "./NotificationDropdown.vue?vue&type=template&id=3eb03a9c&scoped=true"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"

import "./NotificationDropdown.vue?vue&type=style&index=0&id=3eb03a9c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3eb03a9c"

export default script